import React from 'react'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import moment from 'moment'
import Group from 'components/utils/Group'
import MarchTravelFrenzyTakeoverBackground from 'components/Common/SiteTakeover/MarchTravelFrenzyTakeoverBackground'
import { MarchTravelFrenzyLogo } from 'components/Common/SiteTakeover/MarchTravelFrenzyLogo'
import Plural from 'components/utils/Formatters/Plural'
import { daysUntilDate } from 'lib/datetime/dateUtils'
import memoize from 'lib/memoize/memoize'
import { ANYWHERE_SEARCH_ITEM } from 'constants/search'
import config from 'constants/config'
import { encodeSearchParams } from 'lib/search/searchUtils'

const getDaysText = memoize((days: number) => {
  if (days === 0) {
    return 'Last day of unmissable offers'
  }
  return <><Plural count={days} singular="day" withCount /> of unmissable offers</>
})

const daysLeft = daysUntilDate(new Date('2025-03-11T23:59:00+1100'))

const searchQuery = encodeSearchParams({
  searchItem: ANYWHERE_SEARCH_ITEM,
  rooms: [config.search.defaultOccupants],
})

const MarchTravelFrenzyTakeover: App.SiteTakeover = {
  id: 'marchtravelfrenzy',
  startDate: moment('2025-03-06T08:00:00+1100'),
  endDate: moment('2025-03-11T23:59:00+1100'),
  brands: new Set(['luxuryescapes']),
  regions: new Set(['SG', 'HK', 'ZA']),
  imageId: '',
  primaryColour: '#F84916',
  palette: 'inverse',
  backgroundElement: MarchTravelFrenzyTakeoverBackground,
  verticals: new Set(['home']),
  heroCarousel: {
    title: 'March Travel Frenzy',
    subtitle: <BodyText variant="large" colour="neutral-one">
      {getDaysText(daysLeft)}
    </BodyText>,
    logo: <MarchTravelFrenzyLogo variant="hero" daysRemaining={daysLeft} />,
    verticals: ['home'],
  },
  landingPage: {
    banner: {
      description: 'March Travel Frenzy',
      bannerAction: {
        to: `/search?${searchQuery}`,
        children: 'View offers',
      },
      logo: <MarchTravelFrenzyLogo variant="pageBanner" daysRemaining={daysLeft} />,
    },
  },
  searchPage: {
    bannerContent: <Group direction="horizontal" gap={16} verticalAlign="center">
      <MarchTravelFrenzyLogo variant="searchBanner" daysRemaining={daysLeft} />
      <VerticalSpacer gap={2}>
        <Heading variant="heading2">March Travel Frenzy</Heading>
      </VerticalSpacer>
    </Group>,
  },
}

export default MarchTravelFrenzyTakeover
